var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.someDevicesUnrestricted)?_c('div',{staticClass:"device-availability-label",class:_vm.classes,on:{"click":_vm.openDevicesModal}},[_c('div',{staticClass:"device-availability-label-text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }